import type { RouteRecordRaw } from "vue-router";

export type AuditRouteOptions = {
  path?: string;
  name?: string;
  meta?: RouteRecordRaw["meta"];
};

export function createAuditRoutes(options: AuditRouteOptions = {}): RouteRecordRaw[] {
  const {
    path = "/admin/audit",
    name = "audit",
    meta = {
      title: "Auditoría",
      breadcrumb: ["Sistema", "Auditoría"],
      requiresAuth: true,
      roles: ["ADMIN"],
    },
  } = options;

  return [
    {
      path,
      name,
      component: () => import("@template/pages/AuditPage.vue"),
      meta,
    },
  ];
}
